export const easeInOutQuad = (elapsedTime: number): number => {
  if (elapsedTime < 0.5) return 2 * elapsedTime * elapsedTime

  return 1 - (-2 * elapsedTime + 2) ** 2 / 2
}

export const linear = (elapsedTime: number): number => elapsedTime

export const easeOutQuad = (elapsedTime: number): number =>
  1 - (1 - elapsedTime) ** 2

export const easeInOutQuadWithGap = (elapsedTime: number): number => {
  const isSkipped = Math.round(Math.random() * 10) < 4

  if (isSkipped) return 0
  return easeInOutQuad(elapsedTime)
}
